import { render, staticRenderFns } from "./UpdateJobSeekerView.vue?vue&type=template&id=36046aaa&scoped=true&"
import script from "./UpdateJobSeekerView.vue?vue&type=script&lang=js&"
export * from "./UpdateJobSeekerView.vue?vue&type=script&lang=js&"
import style0 from "./UpdateJobSeekerView.vue?vue&type=style&index=0&id=36046aaa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36046aaa",
  null
  
)

export default component.exports